module.exports = {
  init: function() {
    return this.xf['@@transducer/init']();
  },
  result: function(result) {
    return this.xf['@@transducer/result'](result);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/ramdasauce/~/ramda/src/internal/_xfBase.js
// module id = 20
// module chunks = 0